import { Injectable, ViewChild } from '@angular/core';
import { ModulesManagerService } from '../classes/Module/modules-manager.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  /**
   * there is the event of ws 
   * shoud be store as array[module_action] = function
   */
  private onFirstLaunch = []
  private firstLaunch = true
  private events = {}
  private bufferSize = 1024 * 1024; // 1024bytes = 1 Ko
  private closeEvents = {}
  private ws: WebSocket = null;
  private connected: boolean = false
  private notifyed: boolean = false
  private connectionFailureCount = 0;
  private looptimer = null;
  private buffered: any = {}
  private tryingToConnect = false
  private url = ""
  private notAvaibleAlert: any;
  private manager: ModulesManagerService;
  private tiemOutTimer: NodeJS.Timeout;
  constructor() { }

  get isConnected(): boolean {
    return this.ws != null && this.connected && this.ws.readyState == WebSocket.OPEN
  }

  get isConnecting(): boolean {
    return this.ws != null && this.ws.readyState == WebSocket.CONNECTING
  }

  set Popup(value: any) {
    this.notAvaibleAlert = value
  }

  private TimeOut() {
    this.ClearTimeOut()
    this.tiemOutTimer = setTimeout(() => {

      if (!this.isConnected) {
        // La connexion n'a pas été établie dans le délai imparti
        LoggerService.warn('La connexion a expiré après le délai d\'attente');
        this.Disconnect()
        this.tryingToConnect = false
      }
      this.tiemOutTimer = null
    }, 5000)
  }

  private ClearTimeOut() {
    if (this.tiemOutTimer) clearTimeout(this.tiemOutTimer)
    this.tiemOutTimer = null
  }

  async LookUpUrl() {
    return this.manager.Tool.isPlatform("web") ? window.location.origin : "https://app.capilite.fr"
    // return "https://test.capilite.fr"
  }

  private async defaultUrl() {
    return this.manager.Tool.isPlatform("web") ? "ws://localhost:420" : "wss://app.capilite.fr:420"
    // return "wss://test.capilite.fr:420"
  }

  // private async getCurrentWsUrl(){
  //   let response = (await fetch(await this.LookUpUrl()+"/ws.txt"))
  //   if (!response?.ok) {
  //     return await this.defaultUrl()
  //   }

  //   return await response.text();
  // }

  private async getCurrentWsUrl(): Promise<string> {
    const response = await fetch(await this.LookUpUrl() + "/ws_v2.txt");
    if (!response?.ok) {
      return await this.defaultUrl();
    }

    const urls = (await response.text()).split('\n').map(url => url.trim()).filter(url => url);
    LoggerService.log("URLs found:", urls)
    if (urls.length === 0) {
      return await this.defaultUrl();
    }

    const checkWsUrl = (url: string): Promise<string> => {
      return new Promise((resolve, reject) => {
        const ws = new WebSocket(url);

        ws.onopen = () => {
          ws.close();
          resolve(url);
        };

        ws.onerror = () => {
          reject(new Error(`URL ${url} is not available`));
        };
      });
    };

    try {
      for (const url of urls) {
        const availableUrl = await checkWsUrl(url).catch(() => null);
        if (availableUrl)
          return availableUrl;
      }
      return await this.defaultUrl();
    } catch (error) {
      return await this.defaultUrl();
    }
  }

  private async urlMaster(): Promise<string> {
    try {
      if (!this.url) this.url = await this.getCurrentWsUrl()
      return this.url

    } catch (error) { // if not work seem we are in production (ios, android or windows app ) so return production server url
      LoggerService.log(error)
      return await this.defaultUrl()
    }
  }

  private getUniqueID = () => {
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    return s4() + s4() + '-' + s4();
  };


  /**
   * store the buffer part and combine all part together
   * @param data event data used to store the buffer
   */
  private parseBufferedData(data: any) {
    if (!this.buffered[data.bufferId]) this.buffered[data.bufferId] = []
    this.buffered[data.bufferId][data.buffered.pos] = data.buffered.buffer
  }

  /**
   * restore the buffered data
   * @param data event data used to identify the buffer
   * @returns null if not found or malformed json data  or the parsed JSON of buffer
   */
  private restorBuffer(data: any) {
    if (!this.buffered[data.bufferId]) {
      LoggerService.error("an erro is occurred when try to parse the client message... closing connection of this user")
      this.Disconnect()
      return false;
    }
    const ret = this.manager.Tool.jsonParse(this.buffered[data.bufferId].join(""), null)
    delete this.buffered[data.bufferId]
    return ret
  }

  /**
   * send to the server the specified action for specified modules with data
   * @param Module the module server side
   * @param Action the action to perform
   * @param Data data to use
   * @param callback
   */
  async Send(Module: string, Action: string, Data: any, callback: boolean = false): Promise<any> {
    let request: any = {
      Module: Module,
      Action: Action,
      Data: Data,
      InternalKeys: this.manager.InternalKeys
    }
    while (this.tryingToConnect && Module != "UserConnection" && Action != "NocNoc")
      await this.manager.Tool.sleep(500)
    if (!this.isConnected && (await this.Connect().catch(e => LoggerService.log(e))) != 1) {
      let resu = await this.manager.OfflineService.OnEvent(Module, Action, Data).catch((e) => {
        return false
      })
      if (!resu) {

        return { error: this.manager.Trad.Parse("STR_ERROR_SERVER") }
      } else {
        return resu
      }
    }
    if (callback) {
      return new Promise((cb, fai) => {
        let rngEvent = "_" + this.getUniqueID()
        request.callback = request.Module + "_" + request.Action + rngEvent
        this.AddEvent(request.Module, request.Action + rngEvent, cb)
        this.sendData(request)
      })
    } else {
      this.sendData(request)
    }
  }

  private getByteSize(str: string) {
    let blob = new Blob([str]);
    const size = blob.size;
    blob = null;
    return size;
  }

  private async sendData(request: any) {
    const data = JSON.stringify(request)
    const byteSize = this.getByteSize(data)
    if (byteSize > this.bufferSize) { // si la taille de la data excede 10Mo alors on vas devoir la découper en X (ratio) partie la data
      this.sendBufferedData(data, byteSize)
    } else
      this.ws.send(data)

  }

  //** use to send huge data */
  private async sendBufferedData(data, byteSize) {
    let ratio = Math.ceil(byteSize / this.bufferSize)
    const bufferSize = Math.ceil(data.length / ratio) // size en byte des partie du buffer   
    let splitedData = data.split("");
    let serialized = "";
    await this.isSendedData()

    const buffer = {
      Action: "storebuffer",
      bufferId: this.getUniqueID(),
      buffered: null
    }

    let i = 0;
    while ((serialized = splitedData.splice(0, bufferSize).join("")) != "") {
      buffer.buffered = {
        pos: i,
        buffer: serialized
      }
      this.ws.send(JSON.stringify(buffer))
      i++
    }


    await this.isSendedData()
    buffer.Action = "restorebuffer"
    buffer.buffered = null
    this.ws.send(JSON.stringify(buffer))
  }

  async isSendedData() {
    while (this.dataLeft)
      await this.manager.Tool.sleep(1)
  }

  private get dataLeft() {
    return this.isConnected && this.ws.bufferedAmount > 0
  }

  private unbindWsEvents() {
    try {
      this.ws.onopen = null;   // Clear the onopen event handler
      this.ws.onclose = null;  // Clear the onclose event handler
      this.ws.onerror = null;  // Clear the onerror event handler
      this.ws.onmessage = null; // Clear the onmessage event handler
      this.ws.close();
    } catch (error) {
      // Handle any errors that may occur during disconnection.
    }
  }

  public Disconnect() {
    try {
      this.unbindWsEvents()
      this.ClearTimeOut()
      this.connected = false
      this.tryingToConnect = false
      this.connectionFailureCount = 0
      this.ws = null
    } catch (e) {

    }
  }



  private Connect(): Promise<number> {
    if (this.tryingToConnect) return
    this.tryingToConnect = true
    return new Promise(async (cb, fail) => {
      await this.manager.Updater.checkForUpdates()
      if (this.isConnected) {
        this.tryingToConnect = false
        this.ClearTimeOut()
        return cb(1)
      }
      try {
        this.ws = new WebSocket(await this.urlMaster())
        this.TimeOut()
      } catch (error) {
        this.Disconnect()
        return fail(this.manager.Trad.Parse("STR_CANT_JOIN_SERVER"))
      }
      // ici on override les fonction onOpen, onError, onMessage et onClose
      this.ws.onopen = async () => {
        this.connected = true
        this.connectionFailureCount = 0
        this.ClearTimeOut()
        this.notifyed = false

        while (this.isConnecting) {
          if (this.isConnected) break
          await this.manager.Tool.sleep(200)
        }

        if (!this.isConnected) {
          this.Disconnect()
          return fail(this.manager.Trad.Parse("STR_CANT_JOIN_SERVER"))
        }
        this.tryingToConnect = false
        let Token = ""
        if (window.localStorage.LastConnectEmail && window.localStorage[window.localStorage.LastConnectEmail]) {
          Token = window.localStorage[window.localStorage.LastConnectEmail]
        }
        await this.Send("UserConnection", "NocNoc", {
          secureCode: "84CAPI420",
          uuid: await this.manager.Tool.GetDeviceId(),
          isLoged: this.manager.Usr.isLoged
        }, true)
        if (Token) {
          let resu = await this.Send("AuthTokens", "CheckToken", {
            Token: Token,
            DeviceInfo: await this.manager.Tool.getDeviceInfo()
          }, true)
          if (!resu.success) {
            window.localStorage[window.localStorage.LastConnectEmail] = ""
          } else {
            if (this.firstLaunch) {
              while (!this.manager.Usr.isLoged)
                await this.manager.Tool.sleep(100)
              //this.firstLaunch = false  
              if (this.manager.Navi.isSelected("welcome"))
                this.manager.Navi.navigateTo("/asks")
            }
          }
        }
        this.fireOnFirstLaunch()
        cb(1)

        this.manager.LoadList("Asks")

      }

      this.ws.onclose = () => {
        if (this.connected)
          this.Close()
        this.Disconnect()
        LoggerService.log("connection was closed")
      }

      this.ws.onerror = (erro) => {
        if (!this.connected) fail(this.manager.Trad.Parse("STR_ERROR_SERVER"))
        this.Disconnect()
        LoggerService.error("Connection error:", erro)
      }

      this.ws.onmessage = async (event) => {
        try {
          let answer = JSON.parse(event?.data)
          switch (answer.Action) {
            case "storebuffer":
              this.parseBufferedData(answer)
              return
            case "restorebuffer":
              answer = this.restorBuffer(answer)
              break
          }
          let action = answer.callback || answer.Module + "_" + answer.Action
          if (typeof answer.error != "undefined" && answer.error != "") this.manager.Tool.notify(this.manager.Trad.Parse(answer.error))

          if (this.events[action] != null && typeof this.events[action] != 'undefined') {
            this.events[action](answer)
          } else {
            if (!this.isSpecifiedEvent(action, answer, ["update", "delete"]))
              LoggerService.warn("the event " + action + " does not exist is it normal ??????? ...... 🤔")
          }

        } catch (e) {
          LoggerService.error(e)
        }
      }

    })
  }

  public OnFirstLaunch(cb) {
    if (!this.firstLaunch) cb()
    else this.onFirstLaunch.push(cb)
  }

  private fireOnFirstLaunch() {
    this.firstLaunch = false
    this.onFirstLaunch.forEach(cb => cb())
  }

  private isSpecifiedEvent(action: string, answer: any, eventsNames: Array<string>): boolean {
    let explode = action.split("_")
    let arg = explode.pop()
    if (!eventsNames.includes(arg)) return false
    this.events[arg](answer)
    return true
  }



  private Close() {
    for (const [key, cb] of Object.entries(this.closeEvents) as Array<[string, any]>) {
      if (cb != null) cb()
    }
  }

  private runConnection() {
    if (this.isConnected || this.tryingToConnect) return

    this.Connect().catch((e) => {
      LoggerService.log(e)
      this.connectionFailureCount++

      if (this.connectionFailureCount >= 2 && !this.notifyed) {
        this.manager.Tool.notify(this.manager.Trad.Parse("STR_CANT_JOIN_SERVER"))
        this.notifyed = true
      }
    })
  }


  AddModuleUpdateEvent(callback: any) {
    this.events["update"] = callback
  }

  AddModuleDeleteEvent(callback: any) {
    this.events["delete"] = callback
  }

  AddEvent(Module: string, Action: string, callback: any) {
    this.events[Module + "_" + Action] = callback
  }

  DeleteEvent(Module: string, Action: string) {
    delete this.events[Module + "_" + Action]
  }

  OnClose(Module: string, Action: string, event) {
    this.closeEvents[Module + "_" + Action] = event
  }

  availableFeatures() {
    if (!this.isConnected) {
      this.displayNotAvaible()
      return false
    }
    return true
  }

  private displayNotAvaible() {
    this.notAvaibleAlert.presentAlert({
      header: this.manager.Trad.Parse('STR_NOT_AVAIBLE_NOW'),
      message: this.manager.Trad.Parse('STR_NOT_AVAIBLE_NOW_DESCRIPTION'),
      cssClass: 'confirm-delete-alert',
      buttons: [
        {
          text: this.manager.Trad.Parse('STR_CANCEL'),
        },
      ],
    })
  }

  initiate(manager: ModulesManagerService) {
    this.manager = manager;
    manager.Tool.sleep(500).then(() => {
      this.looptimer = setInterval(this.runConnection.bind(this), 500)
    })
  }


}